import React from 'react';
import {Spinner} from "../index";

const Index = () => {
    return <>
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            width: '100%',
            position: 'fixed',
            left: 0,
            top: 0,
        }}>
            <Spinner color={"success"} size={3} />

        </div>
    </>
};

export default Index;